(() => {
  // runtime/circuit-v2/footer.js
  (() => {
    const deck = document.getElementById("boxbox-circuit");
    const frame = deck?.querySelector("iframe");
    const documentTemplate = document.getElementById("boxbox-circuit-document");
    const shell = document.querySelector("[data-site-shell]");
    if (!deck || !frame || !documentTemplate || !shell) return;
    let opened = false, priorInert = false, trigger = null;
    function focusGame() {
      frame.contentWindow.postMessage({ type: "boxbox-circuit-focus" }, location.origin);
    }
    function show(button) {
      if (opened) return;
      opened = true;
      trigger = button;
      deck.hidden = false;
      deck.inert = false;
      document.documentElement.style.setProperty("--bb-race-lift", deck.getBoundingClientRect().height + "px");
      document.documentElement.classList.add("bb-race-open");
      priorInert = shell.inert;
      shell.inert = true;
      trigger.setAttribute("aria-expanded", "true");
      if (!frame.hasAttribute("srcdoc")) frame.srcdoc = documentTemplate.innerHTML;
      else focusGame();
      frame.focus();
    }
    function hide() {
      if (!opened) return;
      opened = false;
      frame.contentWindow.postMessage({ type: "boxbox-circuit-pause" }, location.origin);
      document.documentElement.classList.remove("bb-race-open");
      shell.inert = priorInert;
      trigger?.setAttribute("aria-expanded", "false");
      deck.inert = true;
      deck.hidden = true;
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    }
    document.addEventListener("click", (event) => {
      const button = event.target.closest("[data-circuit-trigger]");
      if (button) {
        event.preventDefault();
        show(button);
      }
    });
    frame.addEventListener("load", () => {
      frame.contentWindow.postMessage({ type: opened ? "boxbox-circuit-focus" : "boxbox-circuit-pause" }, location.origin);
    });
    window.addEventListener("message", (event) => {
      if (event.origin === location.origin && event.source === frame.contentWindow && event.data?.type === "boxbox-circuit-close") hide();
    });
    window.addEventListener("keydown", (event) => {
      if (opened && event.key === "Escape") {
        event.preventDefault();
        hide();
      }
    });
    window.addEventListener("resize", () => {
      if (opened) document.documentElement.style.setProperty("--bb-race-lift", deck.getBoundingClientRect().height + "px");
    });
  })();
})();
